import { IconProps } from "./";
import Icon from "./assets/checked_24.svg";
import { BaseIcon } from "./BaseIcon";

export function Icon24Checked(props: IconProps) {
  return <BaseIcon icon={<Icon />} {...props} />;
}
